// extracted by mini-css-extract-plugin
export default {"starterScreen":"Kh","starterImage":"Lh","already":"Mh","btnContainer":"Nh","starterImageMobile":"Oh","starterTextContainWrapper":"Ph","controlX":"Qh","attrWrapper":"Rh","logoWrapper":"Sh","starterTextContain":"Th","starterHeader":"Uh","starterBtn":"Vh","starterSecondaryBtn":"Wh","starterBanner":"Xh","logoWrapperMob":"Yh","mobileBtnContainer":"Zh"};
    if(module.hot) {
      // 1726593102868
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  